import axios from "axios";

const API_SERVICE = `${process.env.REACT_APP_ENVIRONMENT}` !== 'DEV' ? '/trocasenha-service' : ':8080';
const API_VERSION = '/v1';

const apiEsqueciSenha = axios.create({
  baseURL: `${process.env.REACT_APP_API_ROOT}${API_SERVICE}${API_VERSION}/reset`
});

export default apiEsqueciSenha;